"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePublicDataGet = usePublicDataGet;
const swr_1 = __importDefault(require("swr"));
const utils_1 = require("../utils");
const usePublicDataClient_1 = require("./usePublicDataClient");
/**
 * Calls `publicDataClient.publicDataGetObject` and returns an SWR response. SWR `revalidateOnFocus` option is set to `false`.
 *
 * @param key - public data key to retrieve, this is optional, if not set backend will not be called and result will not be returned
 * @param appName - optional appName, if not set `window.appName` will be used
 * @param config - custom SWR configuration object, can be used to remove the custom `laggy` middleware
 */
function usePublicDataGet(key, appName, config) {
    const resolvedAppName = (0, utils_1.getAppName)(appName);
    const publicData = (0, usePublicDataClient_1.usePublicDataClient)(resolvedAppName);
    return (0, swr_1.default)(key ? ['/platform/public-data/get', key] : undefined, async ([, key]) => {
        return key ? publicData.publicDataGetObject(key) : undefined;
    }, config ?? {
        revalidateOnFocus: false,
    });
}
